import { organisations } from './organisations';
import { residents } from './residents';
import { devices } from './devices';
import { familyMembers } from './family-members';

export const API = {
  organisations,
  residents,
  devices,
  familyMembers,
};
